import { render, staticRenderFns } from "./HvDepotCell.vue?vue&type=template&id=1018879e"
import script from "./HvDepotCell.vue?vue&type=script&lang=js"
export * from "./HvDepotCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports